/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PublishStatusUnlisted({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#PublishStatusUnlisted_svg__a)"><rect width={14} height={12} x={1} y={2} strokeLinejoin="round" rx={2} /><path d="M8.73 4.643a3.041 3.041 0 0 0-3.655 3.938m5.518-2.487a3.037 3.037 0 0 1-3.943 4.233" /><path strokeLinejoin="round" d="m10.146 9.89 1.23 1.23M11.845 4.412l-6.687 7.176" /></g><defs><clipPath id="PublishStatusUnlisted_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;